import axiosInstance from "@/api/axiosInstance";
import { GetEventSessionRegistrationInfoResponse } from "./types";

export const getEventSessionRegistrationInfo = async (
  eventSessionUuid: string,
): Promise<GetEventSessionRegistrationInfoResponse> => {
  const response =
    await axiosInstance.get<GetEventSessionRegistrationInfoResponse>(
      `/api/private/event-sessions/${eventSessionUuid}/registration-info`,
    );

  return response.data;
};
